var _defs, _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPilotagecabinet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 375.37 375.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#D\xE9grad\xE9_sans_nom_20);}.cls-2{fill:#f5f5f5;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_20",
    x1: 313.68,
    y1: 405.91,
    x2: 61.69,
    y2: -30.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6068ae",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#585e93",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a4d65",
    stopOpacity: 0.95
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "P-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 375.37,
    height: 375.37,
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M768.87,349.9q0,25.74-9.59,44.91a73.38,73.38,0,0,1-9.72,14.74,66.5,66.5,0,0,1-17.76,14.71h0A50,50,0,0,1,707,430.87s-46.28-1-46.52-1a7.13,7.13,0,0,0-7.23,5.06l-26.54,79.83a13.28,13.28,0,0,1-25.9-4.19,12.85,12.85,0,0,1,.67-4.19s30-90.82,33.11-95.93c1.76-2.93,4.09-5.62,10.35-6.18h60.47a26.19,26.19,0,0,0,20.13-9.45h0Q738,379.63,738,349.9q0-29.46-12.5-44.64l-.16-.19a35.81,35.81,0,0,0-27.59-13h-84c-6.55,0-12.6-4.4-13.79-10.83a13.31,13.31,0,0,1,13.08-15.74h77a90.36,90.36,0,0,1,26.14,3.61,73.75,73.75,0,0,1,15.58,6.67,68.46,68.46,0,0,1,27.48,29.33Q768.88,324.18,768.87,349.9Z",
    transform: "translate(-496.63 -207)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilotagecabinet);
export default __webpack_public_path__ + "static/media/pilotagecabinet.19c345e78d0580a34d319d41429e3d84.svg";
export { ForwardRef as ReactComponent };